export const CONSENT_COMPLETED = 'consent-completed';
export const CONSENT_STATUS_REJECTED = 'declined';

export const CONSENT_OPTIONS = {
  AUDIO: 'audio',
  DOCUMENT: 'document',
  EMAIL_ADDRESS: 'email_address',
  ON_SCREEN: 'on_screen',
  ON_SCREEN_ATTESTATION: 'user_attestation',
  PHONE_NUMBER: 'phone_number',
  SELECTED_CONSENT_TYPE: 'selectedConsentType',
  LANGUAGE: 'language',
  NH_DOCUMENT: 'nh_document',
  NH_DOCUMENT_REFERRALS: 'nh_document_referrals',
  NH_DOCUMENT_REFERRAL_SPECIFIC: 'nh_document_referral_specific',
  NH_DOCUMENT_STATE_SHARE: 'nh_document_state_share',
};

export const DIGITAL_CONSENT_TYPES = [
  CONSENT_OPTIONS.PHONE_NUMBER,
  CONSENT_OPTIONS.EMAIL_ADDRESS,
  CONSENT_OPTIONS.ON_SCREEN,
];

export const CONSENT_TYPE_PLATFORM_SERVICES = 'platform-services';
export const CONSENT_TYPE_LINK_AGREEMENT = 'link-agreement';

export const CONSENT_FORM_HEADER_MESSAGE = `If you will be servicing this
  client or sending referrals on their behalf, you will need to obtain their consent
  to do so.  You may request consent from the client via email or SMS, or you
  may upload a signed consent document below`;

export const CONSENT_LINK_FORM_HEADER_MESSAGE = `You must obtain an agreement to
 link this family member’s records on your client’s face sheet. You may request
 linkage via email or SMS, or you may upload a signed agreement document below.`;

export const CHOOSE_PREFERRED_LANGUAGE_MESSAGE = 'Please choose your client\'s preferred language';

export const NH_SET_TITLE = 'nh-set-title';

export const NH_LANGUAGE_ENUMS = [
  {
    display_name: 'Arabic',
    value: 'ar',
  },
  {
    display_name: 'Bosnian',
    value: 'bs',
  },
  {
    display_name: 'Chinese (Simplified)',
    value: 'zh',
  },
  {
    display_name: 'English',
    value: 'en',
  },
  {
    display_name: 'French',
    value: 'fr',
  },
  {
    display_name: 'Haitian-Creole',
    value: 'ht',
  },
  {
    display_name: 'Kinyarwanda',
    value: 'rw',
  },
  {
    display_name: 'Nepali',
    value: 'ne',
  },
  {
    display_name: 'Portuguese',
    value: 'pt',
  },
  {
    display_name: 'Russian',
    value: 'ru',
  },
  {
    display_name: 'Somali',
    value: 'so',
  },
  {
    display_name: 'Spanish',
    value: 'es',
  },
  {
    display_name: 'Swahili',
    value: 'sw',
  },
  {
    display_name: 'Ukrainian',
    value: 'uk',
  },
  {
    display_name: 'Vietnamese',
    value: 'vi',
  },
];
